// React imports.
import React from "react";

//app imports
import {Assessment2bHHDataReceivedStatusEnum} from "../state";

const Assessment2bMainTableRow = ({ state, fuel, step, fieldChangeHandler, rowClass }) => (
    <React.Fragment>
        <div className={"dwGridRow col1 "+ rowClass} >{fuel.description}</div>
        <div className={"dwGridRow  col2 blue-background "+ rowClass}>
            <input id="totalAssistedhHNum" name="totalAssistedhHNum" value={fuel.totalAssistedhHNum} 
                onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                className="form-control " />
        </div>
        <div className={"dwGridRow  col3 yellow-background "+ rowClass} >
            <input id="hHElectricDataReceivedNum" name="hHElectricDataReceivedNum" value={fuel.hHElectricDataReceivedNum} 
              onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
              className="form-control " />
        </div>

        {step.showDataReceivedStatus === true &&
            <React.Fragment>
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
                    || fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.EntryError)
                    &&
                    <div className={"dwGridRow col4 red-background "+ rowClass} >
                        {fuel.hHDataReceivedPercentString}
                    </div>
                }
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues)
                    &&
                    <div className={"dwGridRow col4 green-background "+ rowClass} >
                        {fuel.hHDataReceivedPercentString}
                    </div>
                }
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
                    &&
                    <div className={"dwGridRow col4 "+ rowClass} >
                        {fuel.hHDataReceivedPercentString} 
                    </div>
                }
            </React.Fragment>
        }
        {step.showDataReceivedStatus === true &&
            <React.Fragment>
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.NotMeetTarget)
                    &&
                    <div className={"dwGridRow col5 red-background "+ rowClass} >
                        <strong>Issue Found - </strong> You did NOT collect data for at
                        least  {fuel.targetPercentHouseholdsCoveredString}   of these households.
                    </div>
                }
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues)
                    &&
                    <div className={"dwGridRow col5 green-background "+ rowClass} >
                        <strong>No Issue - </strong> You collected data for at
                        least   {fuel.targetPercentHouseholdsCoveredString}   of these households.
                    </div>
                }
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
                    &&
                    <div className={"dwGridRow col5 "+ rowClass} >
                        N/A
                    </div>
                }
                {(fuel.hhDataReceivedStatus2b ==Assessment2bHHDataReceivedStatusEnum.EntryError)
                    &&
                    <div className={"dwGridRow col5  red-background "+ rowClass} >
                        Data entry error.
                    </div>
                }
            </React.Fragment>
        } 
    </React.Fragment>
);

export default Assessment2bMainTableRow;
